
// // import React, { useEffect, useState, useMemo } from 'react';
// // import { Col, Container, Row } from 'react-bootstrap';
// // import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
// // import HomeTitle from '../components/HomeTitle/HomeTitle';
// // import { useDispatch, useSelector } from 'react-redux';
// // import Table from "../components/Table/Table";
// // import { useNavigate } from 'react-router-dom';
// // import { fetchStudents } from '../hooks/students';
// // import CustomBtn from '../components/CustomBtn/CustomBtn';
// //   import * as XLSX from "xlsx";
// // import { saveAs } from "file-saver";
// // import { fetchRegisterRegisterStudents } from '../hooks/registerStudents';

// // function StudentsSchoolExpenses() {
// // const navigate = useNavigate();
// // const dispatch = useDispatch();
// // const { currentLocal } = useSelector((state) => state.currentLocal);
// // const { list: items } = useSelector((state) => state.Students);
// // const { list: studentsItems } = useSelector((state) => state.registerStudents);
// // const [searchText, setSearchText] = useState("");
// // console.log(studentsItems);
// // console.log(items);

  // useEffect(() => {
  //   dispatch(fetchStudents());
  //   dispatch(fetchRegisterRegisterStudents());

  // }, []);

// //   // تجميع البيانات بحيث يتم أخذ الرؤوس من details والبيانات من payments
// //   // const result = useMemo(() => {
// //   //   const grouped = {};
// //   //   items.forEach((item) => {
// //   //     const studentId = item.student.id;
// //   //     if (!grouped[studentId]) {
// //   //       grouped[studentId] = {
// //   //         student: item.student,
// //   //         details: [], // لاستخراج الرؤوس
// //   //         payments: [], // لتعبئة الجسم
// //   //         amount_due: item.amount_due,
// //   //         cumulative_paid: item.cumulative_paid,
// //   //         expense_price: item.expense_price,
// //   //       };
// //   //     }


// //   //     // إضافة الدفعة الحالية للمصفوفة
// //   //     grouped[studentId].payments.push({
// //   //       amount_paid: item.amount_paid,
// //   //       created_at: item.created_at,
// //   //       is_registration_fee: item.is_registration_fee,
// //   //       // ربط الدفعة باسم البند لضمان وضعها في العمود الصحيح
// //   //       payment_type: item.details?.[0]?.name 
// //   //     });

// //   //     // جمع أسماء البنود الفريدة للرؤوس
// //   //     item.details?.forEach((detail) => {
// //   //       const exists = grouped[studentId].details.find(d => d.name === detail.name);
// //   //       if (!exists) {
// //   //         grouped[studentId].details.push({ name: detail.name });
// //   //       }
// //   //     });
// //   //   });
// //   //   return Object.values(grouped);
// //   // }, [items]);




// //   const result = useMemo(() => {
// //   const grouped = {};
// //   items?.student_expenses?.data?.forEach((item) => {
// //     console.log(item);

// //     const studentId = item.student.id;
// //     if (!grouped[studentId]) {
// //       grouped[studentId] = {
// //         student: item.student,
// //         grade:item?.grade?.name,
// //         grade_category:item?.grade?.grade_category?.name,
// //         details: [],
// //         payments: [],
// //         amount_due: item.amount_due,
// //         // cumulative_paid:item.exception_price?Number(item.exception_price) - Number(item.cumulative_paid) :item.cumulative_paid,
// //         cumulative_paid:item.cumulative_paid,
// //         expense_price: item.exception_price ?? item.expense_price,
// //       };
// //     }

// //     grouped[studentId].payments.push({
// //       amount_paid: item.amount_paid,
// //       created_at: item.created_at,
// //       is_registration_fee: item.is_registration_fee,
// //       payment_type: item.details?.[0]?.name
// //     });

// //     item.details?.forEach((detail) => {
// //       const exists = grouped[studentId].details.find(d => d.name === detail.name);
// //       if (!exists) {
// //         grouped[studentId].details.push({ name: detail.name });
// //       }
// //     });
// //   });

// //   // عكس الدفعات لكل طالب
// //   Object.values(grouped).forEach(student => {
// //     student.payments.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
// //     // لو عايزة بالعكس خالص:
// //     student.payments.reverse();
// //   });

// //   return Object.values(grouped);
// // }, [items.student_expenses]);


// //   const detailNames = [...new Set(result.flatMap(s => s.details.map(d => d.name)))];

// // const headerIterm = [
// //   currentLocal.home.ID,
// //   currentLocal.home.namePlaceholder,
// //   currentLocal.home.Stage,
// //   currentLocal.home.grade,
// //   ...detailNames, // الرؤوس من الـ Details
// //   currentLocal.home.RemainingPrice,
// //   currentLocal.home.amount_paid,
// //   currentLocal.home.Total,
// //   "",
// // ];
// // const alldata = [...(result || []), ...(items?.recently_created_students || [])];
// // console.log(alldata,"alldata");
// //   // const allStudents = [
// //   //   ...alldata,
// //   //   ...studentsItems
// //   // ];

// // const allStudents = studentsItems.filter(student =>
// //   !alldata.some(s =>
// //     (s.student?.id || s.id) === student.id
// //   )
// // );
// // const finalStudents = [...alldata, ...allStudents];
// // console.log(finalStudents,"finalStudents");

// // const filteredStudents = useMemo(() => {
// //   if (!searchText) return finalStudents;

// //   return finalStudents.filter((item) => {
// //     const name = item.student ? item.student.name : item.name;
// //     const id = item.student ? item.student.id : item.id;

// //     return (
// //       name?.toLowerCase().includes(searchText.toLowerCase()) ||
// //       id?.toString().includes(searchText)
// //     );
// //   });
// // }, [searchText, finalStudents]);
// //   const body = (
// //     <tbody>
// //       {/* {finalStudents?.map((item, index) =>{ */}
// //         {filteredStudents?.map((item, index) => {
// //         console.log(item,"itemitem");

// //         return(
// //         <tr key={index}>
// //           <td>{item.student?item?.student?.id:item.id}</td>
// //           <td style={{ minWidth: "150px" }}>{item.student?item.student?.name:item?.name}</td>
// //           <td>{item?.grade_category?item?.grade_category:item?.grade?.grade_category?.name || "---"}</td>
// //           <td>{item?.grade?.name?item?.grade?.name:item?.grade || "---"}</td>

// // {detailNames.map((headerName, idx) => {
// // const currentPayment = item?.payments?.[idx];
// // console.log(item?.expense_price,"currentPayment");
// // console.log(Number(item.expense_price)-Number(item.cumulative_paid),"cxzxzxurrentPayment");
// // console.log(item);
// // console.log(Number(item.cumulative_paid),"cxzxzxurrentPayment");

// //   return (
// //     <td key={idx} className="text-center p-0" style={{ minWidth: "120px", borderRight: "1px solid #eee" }}>
// //       {currentPayment ? (
// //         <div 
// //           className="px-2 py-2 h-100 d-flex flex-column justify-content-center"
// //           style={{ backgroundColor: currentPayment.is_registration_fee ? "#f0fff4" : "transparent" }}
// //         >
// //           <span className="fw-bold text-success">{currentPayment.amount_paid}</span>
// //           <div style={{ fontSize: "10px", color: "#888" }}>
// //             {currentPayment.created_at} 
// //           </div>
// //         </div>
// //       ) : (
// //         <span className="text-muted" style={{ opacity: 0.3 }}>---</span>
// //       )}
// //     </td>
// //   );
// // })}

// //           {/* <td className="fw-bold text-danger">{item.amount_due}</td> */}
// //           <td className="fw-bold text-danger">{Number(item.expense_price)-Number(item.cumulative_paid)}</td>
// //           <td className="fw-bold text-primary">{item.cumulative_paid}</td>
// //           <td>{item.expense_price}</td>
//           <td>

//             <button className='btn btn-sm btn-outline-info mx-2' 
//              onClick={() => navigate(!item.student?`/payment/${item.student?item.student.id:item?.id}/${item?.grade?.id }`:`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
//               {currentLocal.home.Academicyearexpenses}
//             </button> 
//             {/* <button className='btn btn-sm btn-outline-info' onClick={() => navigate(`/dashboard/student/${item.student?item.student.id:item.id}`)}>
//               {currentLocal.home.Preview}
//             </button> */}
//             {/* {item?.payments!=undefined&&item?.payments.find((item)=>item?.is_registration_fee==1)&&item?.cumulative_paid!=item?.expense_price&&
//             <> */}
//          {/* <button className='btn btn-sm btn-outline-info mx-2' 
//              onClick={() => navigate(`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
//               {currentLocal.home.Academicyearexpenses}
//             </button>   */}

//             {/* {!item.student&&     
//              <button className='btn btn-sm btn-outline-info mx-2' 
//              onClick={() => navigate(!item.student?`/payment/${item.student?item.student.id:item?.id}/${item?.grade?.id }`:`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
//               {currentLocal.home.Academicyearexpenses}
//             </button>
// } */}
//           </td>
// //         </tr>
// //       )})}
// //     </tbody>
// //   );




// //   return (
// //     // استخدام container-fluid و w-100 لضمان ملء الشاشة
// // <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
// //   <Container fluid className="px-4"> 
// //     <AuthNavbar />
// //         <div className="mt-4">
// //             {/* <HomeTitle title={currentLocal.home.students} /> */}
// //             <div className="d-flex justify-content-between align-items-center mb-4">
// //   <HomeTitle title={currentLocal.home.students} />
// //   <div>
// //     <input
// //       className='form-control'
// //       style={{ width: "300px", display: "inline-block", marginRight: "10px" }}
// //       placeholder={currentLocal.home.search}
// //       value={searchText}
// //       onChange={(e) => setSearchText(e.target.value)}
// //     />
// //     <button 
// //   className="btn btn-sm btn-outline-primary mx-4"
// //   onClick={() => window.print()}
// //     >
// // <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
// //   <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/>
// //   <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/>
// // </svg>    </button>


// //   </div>

// // </div>
// // <div>
// // <Row>
// //     <Col md={6}></Col>
// //               <Col md={6}>
// //               <div className='d-flex justify-content-end'>
// //                 <div className='w-50 d-flex justify-content-start mb-3'>
// //                   <CustomBtn text={currentLocal.home.add} clickingFunction={()=>navigate("/choose-stage")} />

// //                 </div>
// //               </div>
// //             </Col>
// // </Row>
// // </div>

// //           {/* الحاوية التي تضمن ظهور الـ Scrollbar بشكل صحيح للجدول العريض */}
// // <div id="printable-table" className="table-responsive shadow-sm bg-white rounded">

// // <Table
// //   data={result}
// //   headerIterm={headerIterm}
// //   actions={["edit"]}
// //   body={body}
// // />
// //           </div>
// //         </div>
// //       </Container>
// //     </div>
// //   );
// // }


// // export default StudentsSchoolExpenses



// import React, { useEffect, useState, useMemo } from 'react';
// import { Col, Container, Row } from 'react-bootstrap';
// import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
// import HomeTitle from '../components/HomeTitle/HomeTitle';
// import { useDispatch, useSelector } from 'react-redux';
// import Table from "../components/Table/Table";
// import { useNavigate } from 'react-router-dom';
// import { fetchStudents } from '../hooks/students';
// import CustomBtn from '../components/CustomBtn/CustomBtn';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { fetchRegisterRegisterStudents } from '../hooks/registerStudents';

// function StudentsSchoolExpenses() {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const { currentLocal } = useSelector((state) => state.currentLocal);
  // const { list: items } = useSelector((state) => state.Students);
  // const { list: studentsItems } = useSelector((state) => state.registerStudents);
  // const [searchText, setSearchText] = useState("");


  // const headerIterm = [
  //   currentLocal.home.ID,
  //   currentLocal.home.ID,
  //   currentLocal.home.namePlaceholder,
  //   currentLocal.home.Stage,
  //   currentLocal.home.grade,
  //   // ...detailNames, // الرؤوس من الـ Details
  //   currentLocal.home.RemainingPrice,
  //   currentLocal.home.amount_paid,
  //   currentLocal.home.Total,
  //   "",
  // ];




  // const allStudents = [
  //   ...studentsItems.map(item => ({
  //     student: item,

  //   })),

  //   ...items?.student_expenses?.data.map(item => ({
  //     student: item?.student,
  //     grade:item?.grade,
  //         grade_category:item?.grade_category_name,
  //         final_amount:item?.exception_price?item?.exception_price:item?.final_amount

  //   })),

  //   ...items?.recently_created_students.map(item => ({
  //     student: item,
  //     grade: item?.grade,
  //     grade_category: item?.grade?.grade_category,

  //   })),
  // ];
// console.log(allStudents?.length);

//   const newArray = [
//     ...new Map(
//       allStudents.map(item => [
//         item.student?.id,
//         item
//       ])
//     ).values(),
//   ];

//   console.log(newArray?.length, "newArray");


//   const body = (
//     <tbody>
//       {/* {finalStudents?.map((item, index) =>{ */}
//       {newArray?.map((item, index) => {
//         console.log(item);

//         return (
//           <tr key={index}>
//             <td>{index + 1}</td>
//             <td>{item.student ? item?.student?.id : item.id}</td>
//             <td style={{ minWidth: "150px" }}>{item.student ? item.student?.name : item?.name}</td>
//             <td>{item?.grade_category ? item?.grade_category?.name?item?.grade_category?.name:item?.grade_category : item?.student?.grade_category?.name}</td>
//             <td>{item?.grade ? item?.grade?.name : item?.student?.grade?.name}</td>

//             {/* {detailNames.map((headerName, idx) => {
// const currentPayment = item?.payments?.[idx];
// console.log(item?.expense_price,"currentPayment");
// console.log(Number(item.expense_price)-Number(item.cumulative_paid),"cxzxzxurrentPayment");
// console.log(item);
// console.log(Number(item.cumulative_paid),"cxzxzxurrentPayment");

//   return (
//     <td key={idx} className="text-center p-0" style={{ minWidth: "120px", borderRight: "1px solid #eee" }}>
//       {currentPayment ? (
//         <div 
//           className="px-2 py-2 h-100 d-flex flex-column justify-content-center"
//           style={{ backgroundColor: currentPayment.is_registration_fee ? "#f0fff4" : "transparent" }}
//         >
//           <span className="fw-bold text-success">{currentPayment.amount_paid}</span>
//           <div style={{ fontSize: "10px", color: "#888" }}>
//             {currentPayment.created_at} 
//           </div>
//         </div>
//       ) : (
//         <span className="text-muted" style={{ opacity: 0.3 }}>---</span>
//       )}
//     </td>
//   );
// })} */}

//             <td className="fw-bold text-danger">{item.final_amount}</td>
//             {/* <td className="fw-bold text-danger">{Number(item.expense_price)-Number(item.cumulative_paid)}</td>
//           <td className="fw-bold text-primary">{item.cumulative_paid}</td>
//           <td>{item.expense_price}</td> */}
//             <td>

//               <button className='btn btn-sm btn-outline-info mx-2'
//                 onClick={() => navigate(!item.student ? `/payment/${item.student ? item.student.id : item?.id}/${item?.grade?.id}` : `/dashboard/student/Finance/${item.student ? item.student.id : item?.id}/${item?.grade?.name ? item?.grade?.name : item?.student?.grade_id}`)}>
//                 {currentLocal.home.Academicyearexpenses}
//               </button>
//               {/* <button className='btn btn-sm btn-outline-info' onClick={() => navigate(`/dashboard/student/${item.student?item.student.id:item.id}`)}>
//               {currentLocal.home.Preview}
//             </button> */}
//               {/* {item?.payments!=undefined&&item?.payments.find((item)=>item?.is_registration_fee==1)&&item?.cumulative_paid!=item?.expense_price&&
//             <> */}
//               {/* <button className='btn btn-sm btn-outline-info mx-2' 
//              onClick={() => navigate(`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
//               {currentLocal.home.Academicyearexpenses}
//             </button>   */}

//               {/* {!item.student&&     
//              <button className='btn btn-sm btn-outline-info mx-2' 
//              onClick={() => navigate(!item.student?`/payment/${item.student?item.student.id:item?.id}/${item?.grade?.id }`:`/dashboard/student/Finance/${item.student?item.student.id:item?.id}/${item?.grade?.name?item?.grade?.name:item?.student?.grade_id }`)}>
//               {currentLocal.home.Academicyearexpenses}
//             </button>
// } */}
//             </td>
//           </tr>
//         )
//       })}
//     </tbody>
//   );

//   return (
    // <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
    //   <Container fluid className="px-4">
    //     <AuthNavbar />
    //     <div className="mt-4">
    //       {/* <HomeTitle title={currentLocal.home.students} /> */}
    //       <div className="d-flex justify-content-between align-items-center mb-4">
    //         <HomeTitle title={currentLocal.home.students} />
    //         <div>
    //           <input
    //             className='form-control'
    //             style={{ width: "300px", display: "inline-block", marginRight: "10px" }}
    //             placeholder={currentLocal.home.search}
    //             value={searchText}
    //             onChange={(e) => setSearchText(e.target.value)}
    //           />
    //           <button
    //             className="btn btn-sm btn-outline-primary mx-4"
    //             onClick={() => window.print()}
    //           >
    //             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
    //               <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
    //               <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
    //             </svg>
    //           </button>


    //         </div>
    //       </div>
    //       <div>
            // <Row>
            //   <Col md={6}></Col>
            //   <Col md={6}>
            //     <div className='d-flex justify-content-end'>
            //       <div className='w-50 d-flex justify-content-start mb-3'>
            //         <CustomBtn text={currentLocal.home.add} clickingFunction={() => navigate("/choose-stage")} />

            //       </div>
            //     </div>
            //   </Col>
            // </Row>
    //       </div>
//           <div id="printable-table" className="table-responsive shadow-sm bg-white rounded">

//             <Table
//               // data={result}
//               headerIterm={headerIterm}
//               actions={["edit"]}
//               body={body}
//             />

//           </div>
//         </div>

//       </Container>

//     </div>
//   )
// }

// export default StudentsSchoolExpenses


// import React, { useEffect, useState, useMemo } from 'react';
// import { Col, Container, Row } from 'react-bootstrap';
// import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
// import HomeTitle from '../components/HomeTitle/HomeTitle';
// import { useDispatch, useSelector } from 'react-redux';
// import Table from "../components/Table/Table";
// import { useNavigate } from 'react-router-dom';
// import { fetcAllStudents, fetchStudents } from '../hooks/students';
// import CustomBtn from '../components/CustomBtn/CustomBtn';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { fetchRegisterRegisterStudents } from '../hooks/registerStudents';

// function StudentsSchoolExpenses() {
//     const navigate = useNavigate();
//   const dispatch = useDispatch();
//     const { currentLocal } = useSelector((state) => state.currentLocal);
//   const { list: items } = useSelector((state) => state.Students);
//   const { list: studentsItems } = useSelector((state) => state.registerStudents);
//   const [searchText, setSearchText] = useState("");
//   useEffect(() => {
//     dispatch(fetchStudents());
//     dispatch(fetchRegisterRegisterStudents());
//     dispatch(fetcAllStudents());

//   }, []);
//   const expenseRecords = useMemo(() => {
//     return items?.student_expenses?.data || items || [];
//   }, [items]);
//     const headerIterm = [
//     currentLocal.home.ID,
//     currentLocal.home.ID,
//     currentLocal.home.namePlaceholder,
//     currentLocal.home.Stage,
//     currentLocal.home.grade,
//     // ...detailNames, // الرؤوس من الـ Details
//     currentLocal.home.RemainingPrice,
//     currentLocal.home.amount_paid,
//     currentLocal.home.Total,
//     "",
//   ];
// const allbody=<tbody>
// {studentsItems?.map((item,index)=>{
//   const payment=items?.student_expenses.data.find((student)=>student.student?.id==item?.id)
//   const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
//                                  || expenseRecords.find(exp => exp.student?.id === student?.id);

//   return(
//   <tr>

//     <td>{index+1}</td>
//         <td>{item?.id}</td>
//         <td>{item?.name}</td>
//                 <td>{item?.grade?.grade_category?.name}</td>

//         <td>{item?.grade?.name}</td>

//     <td className="text-danger fw-bold">{record ? record.amount_due : "-"}</td>
//                       <td className="text-success">{record ? record.cumulative_paid : "-"}</td>
//                       <td className="fw-bold">
//                         {record ? (record.exception_price ? record.exception_price : record.final_amount) : "-"}
//                       </td>
//     {/* <td>{payment?.amount_due}</td>
//     <td>{payment?.cumulative_paid}</td>
//     <td>{payment?.exception_price?payment?.exception_price:payment?.final_amount}</td> */}
//   </tr>
//   )
// })}

// </tbody>
// const body=<tbody>
//   <tr>studentsItems</tr>

// {studentsItems?.map((item,index)=>{
//   return(
//   <tr>

//     <td>{index+1}</td>
//     <td>{item?.id}</td>
//     <td>kjh</td>


//   </tr>
//   )
// })}

// </tbody>
//   return (
//     <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
//       <Container fluid className="px-4">
//         <AuthNavbar />
//         <div className="mt-4">
//           {/* <HomeTitle title={currentLocal.home.students} /> */}
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <HomeTitle title={currentLocal.home.students} />
//             <div>
//               <input
//                 className='form-control'
//                 style={{ width: "300px", display: "inline-block", marginRight: "10px" }}
//                 placeholder={currentLocal.home.search}
//                 value={searchText}
//                 onChange={(e) => setSearchText(e.target.value)}
//               />
//               <button
//                 className="btn btn-sm btn-outline-primary mx-4"
//                 onClick={() => window.print()}
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
//                   <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
//                   <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
//                 </svg>
//               </button>


//             </div>
//           </div>
//           <div>
//             <Row>
//               <Col md={6}></Col>
//               <Col md={6}>
//                 <div className='d-flex justify-content-end'>
//                   <div className='w-50 d-flex justify-content-start mb-3'>
//                     <CustomBtn text={currentLocal.home.add} clickingFunction={() => navigate("/choose-stage")} />

//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </div>

//           <div>
//             <Table
// body={allbody}
// headerIterm={headerIterm}
//             />
//           </div>
    
//           </div>
//           </Container>
            
//     </div>
//   )
// }

// export default StudentsSchoolExpenses



import React, { useEffect, useState, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
import HomeTitle from '../components/HomeTitle/HomeTitle';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetcAllStudents, fetchStudents } from '../hooks/students';
import { fetchRegisterRegisterStudents } from '../hooks/registerStudents';
import CustomBtn from '../components/CustomBtn/CustomBtn';

function StudentsSchoolExpenses() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: items } = useSelector((state) => state.Students);
  const { list: studentsItems } = useSelector((state) => state.registerStudents);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    dispatch(fetchStudents());
    dispatch(fetchRegisterRegisterStudents());
    dispatch(fetcAllStudents());
  }, [dispatch]);

  // استخراج مصفوفة المصاريف بشكل آمن
  const expenseRecords = useMemo(() => {
    return items?.student_expenses?.data || items || [];
  }, [items]);

  // 1. استخراج أسماء الأقساط/الشهور الفريدة ديناميكياً من البيانات (مثل: سبتمبر، أكتوبر، مقدم الدفع...)
  const dynamicDetailNames = useMemo(() => {
    const namesSet = new Set();
    if (Array.isArray(expenseRecords)) {
      expenseRecords.forEach(record => {
        record.details?.forEach(detail => {
          if (detail.name) namesSet.add(detail.name);
        });
      });
    }
    return Array.from(namesSet);
  }, [expenseRecords]);

  // 2. بناء عناوين الجدول بدمج العناوين الثابتة مع الشهور الديناميكية
  const tableHeaders = useMemo(() => {
    return [
      "#",
      currentLocal.home.ID,
      currentLocal.home.namePlaceholder,
      currentLocal.home.Stage,
      currentLocal.home.grade,
      ...dynamicDetailNames, 
      currentLocal.home.RemainingPrice,
      currentLocal.home.amount_paid,
      currentLocal.home.Total
    ];
  }, [currentLocal, dynamicDetailNames]);

  // 3. تصفية الطلاب بناءً على نص البحث (الاسم أو الرقم المعرف)
  const filteredStudents = useMemo(() => {
    if (!studentsItems) return [];
    if (!searchText.trim()) return studentsItems;

    return studentsItems.filter(student => 
      student?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      student?.id?.toString().includes(searchText)
    );
  }, [studentsItems, searchText]);
// 1. Calculate the total remaining price for all filtered students
const totalRemainingPrice = filteredStudents.reduce((sum, student) => {
  // Find the student's main expense record (same logic used inside your map)
  const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
              || expenseRecords.find(exp => exp.student?.id === student?.id);

  // Calculate total fee for this student
  const total = record ? (record.exception_price ? record.exception_price : record.final_amount) : 0;
  
  // Calculate remaining for this student (Total - Cumulative Paid)
  const cumulativePaid = record ? Number(record.cumulative_paid) : 0;
  const remaining = Number(total) - cumulativePaid;

  return sum + remaining;
}, 0);
// Calculate the total cumulative paid amount for all filtered students
const grandTotalPaid = filteredStudents.reduce((sum, student) => {
  // Find the student's main expense record
  const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
              || expenseRecords.find(exp => exp.student?.id === student?.id);

  // Get the cumulative paid amount for this student
  const cumulativePaid = record ? Number(record.cumulative_paid) : 0;

  return sum + cumulativePaid;
}, 0);
  return (
    <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <Container fluid className="px-4">
        <AuthNavbar />
        
        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <HomeTitle title={currentLocal.home.students} />
            <div>
              <input
                className="form-control"
                style={{ width: "300px", display: "inline-block", marginRight: "10px" }}
                placeholder={currentLocal.home.search}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
            <Row>
              <Col md={6}></Col>
              <Col md={6}>
                <div className='d-flex justify-content-end'>
                  <div className='w-50 d-flex justify-content-start mb-3'>
                    <CustomBtn text={currentLocal.home.add} clickingFunction={() => navigate("/choose-stage")} />

                  </div>
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={7} className='mb-2'>
        <div className='d-flex align-items-center '>
                <h5>{currentLocal.home.RemainingPrice} :</h5>
              <h5>       {filteredStudents.reduce((sum, student) => {
             const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
                          || expenseRecords.find(exp => exp.student?.id === student?.id);
             const total = record ? (record.exception_price ? record.exception_price : record.final_amount) : 0;
             return sum + (Number(total) - Number(record ? record.cumulative_paid : 0));
           }, 0)}</h5>
           <h5>{currentLocal.home.currancy}</h5>
        </div>
              </Col>
                  <Col md={7} className='mb-2'>
        <div className='d-flex align-items-center '>
                <h5>{currentLocal.home.amount_paid} : </h5>
              <h5>    {filteredStudents.reduce((sum, student) => {
             const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
                          || expenseRecords.find(exp => exp.student?.id === student?.id);
             return sum + Number(record ? record.cumulative_paid : 0);
           }, 0)}
           </h5>
           <h5>{currentLocal.home.currancy}</h5>
        </div>
              </Col>
                  <Col md={7} className='mb-2'>
        <div className='d-flex align-items-center'>
                <h5>{currentLocal.home.RemainingPrice} : </h5>
              <h5>       {filteredStudents.reduce((sum, student) => {
             const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
                          || expenseRecords.find(exp => exp.student?.id === student?.id);
             const total = record ? (record.exception_price ? record.exception_price : record.final_amount) : 0;
             return sum + (Number(total) - Number(record ? record.cumulative_paid : 0));
           }, 0)}</h5>
           <h5>{currentLocal.home.currancy}</h5>
        </div>
              </Col>
              
            </Row>
          {/* الجدول الرئيسي للطلاب والمصاريف */}
          <div className="table-responsive bg-white rounded shadow-sm p-3">
            <table className="table table-striped align-middle" dir="rtl">
              <thead>
                <tr>
                  {tableHeaders.map((header, idx) => (
                    <th key={idx}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((student, index) => {
                  console.log(expenseRecords);
                  
                  // العثور على الكائن الأساسي للمصاريف الدراسية (تفضيل الحساب الشامل المتمثل في is_registration_fee === 0)
                  const record = expenseRecords.find(exp => exp.student?.id === student?.id && exp.is_registration_fee === 0) 
                                 || expenseRecords.find(exp => exp.student?.id === student?.id);



                                 const total=record ? (record.exception_price ? record.exception_price : record.final_amount) : 0
                  return (
                    <tr key={student?.id || index}>
                      <td>{index + 1}</td>
                      <td>{student?.id}</td>
                      <td>{student?.name}</td>
                      <td>{student?.grade?.grade_category?.name || "-"}</td>
                      <td>{student?.grade?.name || "-"}</td>
                      
                      {/* طباعة قيم الأقساط الشهرية متطابقة بدقة مع العمود الخاص بها */}
          {dynamicDetailNames.map((headerName, idxName) => {
  const detailItem = record?.details?.find(
    d => d.name === headerName
  );

  // جميع دفعات الطالب
  const studentPayments = expenseRecords.filter(
    exp => exp.student?.id === student?.id
  );

  // ترتيب الدفعات
  const payment = studentPayments[idxName];

  return (
    <td key={idxName} className="text-center">
      {detailItem ? (
        <div>
        

          <div className="fw-bold text-success">
            {payment?.amount_paid || "_"}
          </div>
            <div className="text-muted small">
            {payment?.date}
          </div>
        </div>
      ) : (
        <span className="text-muted" style={{ opacity: 0.4 }}>
          ---
        </span>
      )}
    </td>
  );
})}

                      <td className="text-danger fw-bold">{Number(total)-Number(record ? record.cumulative_paid : 0)}</td>
                      <td className="text-success">{record ? record.cumulative_paid : "-"}</td>
                      <td className="fw-bold">
                        {record ? (record.exception_price ? record.exception_price : record.final_amount) : "-"}
                      </td>
<td>
  <button 
    className='btn btn-sm btn-outline-info mx-2' 
    onClick={() => {
      // 1. التحقق مما إذا كان الطالب لديه سجل مصاريف مرتبط
      const hasRecord = expenseRecords.some(exp => exp.student?.id === student?.id);

      if (hasRecord) {
        // إذا كان لديه سجل، يذهب لصفحة Finance
        navigate(`/dashboard/student/Finance/${student.student?.id || student.id}/${student.grade?.name || student.student?.grade_id}`);
      } else {
        // إذا لم يكن لديه سجل، يذهب لصفحة الدفع (Payment)
        navigate(`/payment/${student.student?.id || student.id}/${student.grade?.id}`);
      }
    }}
  >
    {currentLocal.home.Academicyearexpenses}
  </button>
</td>

                    </tr>
                  );
                })}
                {filteredStudents.length === 0 && (
                  <tr>
                    <td colSpan={tableHeaders.length} className="text-center py-4 text-muted">
                      لا توجد سجلات مطابقة للبحث.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>

        </div>
      </Container>
    </div>
  );
}

export default StudentsSchoolExpenses;